export const getDistance = (distance?: number | null) => {
  if (!distance) return '0 м';
  if (distance > 1000) return `${(distance / 1000).toFixed(1)} км`;
  return `${distance} м`;
};
